import { useEffect, useState } from "react";
import LeftMenuItemGroupTitle from "src/components/navigation/leftNavigation/LeftMenuItemGroupTitle";
import LeftMenuItemLink from "src/components/navigation/leftNavigation/LeftMenuItemLink";
import { classNames } from "src/helpers/classNames";

const LeftMenuItemGroup = ({ data, group_id, page_id, isSubGroup = false, searchTerm, handleMenuClick = () => {} }) => {
  const [isSubmenu, setIsSubmenu] = useState(data.isOpen ? data.isOpen : false);
  const [isSubmenuSearchOpened, setIsSubmenuSearchOpened] = useState(false);
  const [imageClassName, setImageClassName] = useState("");
  const [menuItems, setMenuItems] = useState([]);

  useEffect(() => {
    if (searchTerm === "") {
      setIsSubmenuSearchOpened(false);
      return;
    }

    const hasMatchInTree = (items) => {
      return items.some((item) => {
        const nameMatches = item.name.toLowerCase().includes(searchTerm.toLowerCase());
        if (nameMatches) return true;

        if (item.submenu && item.submenu.length > 0) {
          return hasMatchInTree(item.submenu);
        }

        return false;
      });
    };

    if (data.submenu && hasMatchInTree(data.submenu)) {
      setIsSubmenuSearchOpened(true);
    } else {
      setIsSubmenuSearchOpened(false);
    }
  }, [searchTerm, data.submenu]);

  useEffect(() => {
    if (!data.submenu) {
      setMenuItems([]);
      return;
    }

    if (!searchTerm || data.name.toLowerCase().includes(searchTerm.toLowerCase())) {
      setMenuItems(data.submenu);
      return;
    }

    const filterMenuItems = (items) => {
      return items
        .map((item) => {
          if (!item.submenu || item.submenu.length === 0) {
            return item.name.toLowerCase().includes(searchTerm.toLowerCase()) ? item : null;
          }
          const nameMatches = item.name.toLowerCase().includes(searchTerm.toLowerCase());
          if (nameMatches) {
            return {
              ...item,
              isOpen: true,
            };
          }
          const filteredChildren = filterMenuItems(item.submenu);

          if (filteredChildren.length === 0) {
            return null;
          }

          return {
            ...item,
            submenu: filteredChildren,
            isOpen: true,
          };
        })
        .filter(Boolean);
    };

    const filtered = filterMenuItems(data.submenu);
    setMenuItems(filtered);
  }, [data.submenu, searchTerm, data.name]);

  const shouldShowSubmenu = (data.submenu && data.submenu.length > 1) || data.subMenuFilteredDown || (data.submenu && data.submenu.some((item) => item.is_group || item.submenu));

  return (
    <div className={classNames("group/main relative", isSubmenu || isSubmenuSearchOpened ? "space-y-2" : "")}>
      <LeftMenuItemGroupTitle
        data={data}
        imageClassName={imageClassName}
        setImageClassName={setImageClassName}
        group_id={group_id}
        page_id={page_id}
        dropdownArrowClass={isSubmenu || isSubmenuSearchOpened ? "-rotate-180" : ""}
        setIsSubmenu={setIsSubmenu}
        isSubmenu={isSubmenu}
        searchTerm={searchTerm}
        avoidUnderlineHover={shouldShowSubmenu}
        isSubGroup={isSubGroup}
      />
      {shouldShowSubmenu && (
        <div className={classNames("relative space-y-2 overflow-hidden transition-all duration-200", isSubmenu || isSubmenuSearchOpened ? "max-h-[9000px]" : "max-h-0")}>
          {menuItems.map((subitem) => {
            if (subitem?.is_group || subitem?.submenu) {
              return (
                <div
                  key={subitem._id || subitem.slug}
                  className="pl-5">
                  <LeftMenuItemGroup
                    data={subitem}
                    group_id={group_id}
                    page_id={page_id}
                    searchTerm={searchTerm}
                    isSubGroup={true}
                    handleMenuClick={handleMenuClick}
                  />
                </div>
              );
            }
            return (
              <LeftMenuItemLink
                key={subitem._id || subitem.slug}
                data={subitem}
                image={subitem?.image}
                group_id={group_id}
                page_id={page_id}
                searchTerm={searchTerm}
                buttonClasses={"!pl-8"}
                handleMenuClick={handleMenuClick}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};

export default LeftMenuItemGroup;
